import {createAmenityAccessLogApi} from "../api/create-amenity-access-log-api";
import {createPropertyAmenityApi} from "../api/create-property-amenity-api";
import {createAmenityAccessLogService, type AmenityAccessLogService} from "../services/create-amenity-access-log-service";
import {createPropertyAmenityService, type PropertyAmenityService} from "../services/create-property-amenity-service";
import {type AmenityConfig} from "./amenity-config";

const accessLogServices = new Map<AmenityConfig["type"], AmenityAccessLogService>();
const propertyAmenityServices = new Map<AmenityConfig["type"], PropertyAmenityService>();

function bindAccessLogService(config: AmenityConfig): AmenityAccessLogService {
  const api = createAmenityAccessLogApi(config.accessLogPath);
  return createAmenityAccessLogService(api);
}

function bindPropertyAmenityService(config: AmenityConfig): PropertyAmenityService {
  const api = createPropertyAmenityApi(config.facilityPath, config.facilitiesListPath);
  return createPropertyAmenityService(api);
}

export function getAccessLogService(config: AmenityConfig): AmenityAccessLogService {
  let service = accessLogServices.get(config.type);
  if (!service) {
    service = bindAccessLogService(config);
    accessLogServices.set(config.type, service);
  }
  return service;
}

export function getPropertyAmenityService(config: AmenityConfig): PropertyAmenityService {
  let service = propertyAmenityServices.get(config.type);
  if (!service) {
    service = bindPropertyAmenityService(config);
    propertyAmenityServices.set(config.type, service);
  }
  return service;
}
